import ReceiptIcon from '@mui/icons-material/Receipt'
import RefreshIcon from '@mui/icons-material/Refresh'
import SearchIcon from '@mui/icons-material/Search'
import { Alert, Button, Grid, Stack } from '@mui/material'
import React, { useState } from 'react'
import {
  Br,
  Cut,
  Line,
  Printer as RPrinter,
  Row,
  Text,
  render,
} from 'react-thermal-printer'
import { AppConfig } from '../../config'
import { usePrinterSettings } from '../../hooks'
import { LightUSB } from '../../libraries'
import { useAppDispatch, useAppSelector } from '../../redux-store/hooks'
import { updatePrinterSettings } from '../../services'
import { BottomSaveBar } from '../client-info/components'
import { PrinterCard } from './components'

interface USBDevice {
  productName: string
  manufacturerName: string
  vendorId: number
  productId: number
}

const Printer: React.FC = () => {
  const printerSettings = useAppSelector(
    (state) => state.clientInfo?.data?.printerSettings
  )
  const dispatcher = useAppDispatch()
  const [device, setDevice] = useState<USBDevice>({
    vendorId: Number(printerSettings.vendorId),
    productId: Number(printerSettings.productId),
    manufacturerName: printerSettings.name,
    productName: printerSettings.name,
  })
  const clientInfo = useAppSelector((state) => state.clientInfo?.data)
  const {
    printerUsb,
    setPrinterUsb,
    printerStatus,
    setPrinterStatus,
    loadPrinterSettings,
  } = usePrinterSettings()

  const addNewPrinter = async () => {
    try {
      const usbObj = await LightUSB.initiateBySelect()
      if (usbObj) {
        const statusObj = await usbObj.connect()
        setPrinterStatus(statusObj.status)
        setPrinterUsb(usbObj)
        setDevice({
          productId: usbObj?.productId,
          vendorId: usbObj?.vendorId,
          manufacturerName: usbObj?.device?.productName || '', //TODO
          productName: usbObj?.device?.productName || '',
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  const savePrinterSettings = async () => {
    try {
      if (device) {
        const { productId, vendorId, manufacturerName } = device
        const resp = await dispatcher(
          updatePrinterSettings({
            printerDetails: {
              ...printerSettings,
              productId: String(productId),
              vendorId: String(vendorId),
              name: manufacturerName,
            },
            clientId: AppConfig.getCLientId() || '',
          })
        )
        //console.log(resp);
        //TODO SHOW SNACKBAR
      }
    } catch (e) {
      console.error(e)
    }
  }

  const testPrint = async () => {
    try {
      const data = await render(
        <RPrinter type="epson" characterSet="pc437_usa">
          <Text
            font={'A'}
            size={{ width: 2, height: 2 }}
            align="center"
            bold={true}
          >
            {clientInfo.clientName}
          </Text>

          <Line />
          <Text
            font={'A'}
            size={{ width: 1, height: 1 }}
            align="center"
            bold={true}
          >
            {clientInfo.address.city}
            {clientInfo.address.state}
            {clientInfo.address.country}
          </Text>
          <Row left={String(clientInfo.PhoneNumber)} right={clientInfo.email} />
          <Br />
          <Text
            font={'A'}
            size={{ width: 3, height: 3 }}
            align="center"
            bold={true}
          >
            BILL OF SUPPLY
          </Text>
          <Text font={'A'} size={{ width: 2, height: 2 }} align="center">
            Bill Buddy POS
          </Text>
          <Text font={'A'} size={{ width: 2, height: 2 }} align="center">
            TEST PRINT
          </Text>
          <Cut />
        </RPrinter>
      )
      if (printerUsb) {
        await printerUsb.print(data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const refereshPrinter = async () => {
    try {
      await printerUsb?.hardRefresh()
      await loadPrinterSettings(true)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Grid container p={6} gap={2}>
      <Grid item xs={12}>
        <Grid item xs={12} md={6} lg={4}>
          <Stack flexDirection={'row'} justifyContent={'flex-start'} gap={1}>
            <Button
              endIcon={<SearchIcon />}
              variant="outlined"
              sx={{ height: 60 }}
              color="primary"
              onClick={addNewPrinter}
            >
              Find New Printer
            </Button>
            <Button
              endIcon={<RefreshIcon />}
              variant="outlined"
              sx={{ height: 60 }}
              color="primary"
              onClick={() => refereshPrinter()}
            >
              {' '}
              Refresh
            </Button>
          </Stack>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid item xs={12} md={6} lg={4}>
          <Stack>
            {printerStatus ? (
              <Alert variant="filled" severity="success">
                Connected
              </Alert>
            ) : (
              <Alert variant="filled" severity="error">
                Disconnected.
              </Alert>
            )}
          </Stack>

          <Stack>{device && <PrinterCard device={device} index={0} />}</Stack>
        </Grid>
      </Grid>
      <BottomSaveBar
        onSave={savePrinterSettings}
        childrenActions={
          printerStatus && (
            <Button
              startIcon={<ReceiptIcon />}
              variant="outlined"
              color="primary"
              onClick={testPrint}
              sx={{ height: 48, my: 1.5 }}
            >
              Test Print
            </Button>
          )
        }
      />
    </Grid>
  )
}

export { Printer }
